import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import plural from 'utils/pluralize';
import Spacer from 'features/shared/Spacer';
import { NumberBlock, NumberElement, Plate, Row, SubHeader, Unit } from 'features/shared/ui/Page';
import { SchoolsApi } from 'api';
import { Api } from 'api/cabmun-api-public';
import LoaderComponent from 'features/shared/Loader';

const Text = styled.div`
  margin-top: 4px;
  font-size: 16px;
  line-height: 22px;
  color: rgba(9, 21, 38, 0.6);
`;

export const GeneralStatistics = () => {
  const [totals, setTotals] = useState<Api.GetSchoolTotals200Response>();

  useEffect(() => {
    async function fetch() {
      try {
        const totals = await SchoolsApi.getSchoolTotals();
        setTotals(totals);
      } catch (e) {}
    }

    fetch();
  }, []);

  const schools = totals?.schools_count || 0;
  const registeredTeachers = totals?.reg_teachers_count || 0;
  const activeTeachers = totals?.active_teachers_count || 0;

  return (
    <Plate data-qa-id="totals_schools">
      <SubHeader>Основные показатели</SubHeader>
      <Spacer size={40} />
      {!totals ? (
        <LoaderComponent />
      ) : (
        <>
          <Row>
            <NumberBlock>
              <NumberElement>{schools}</NumberElement>
              <Spacer size={8} inline />
              <Unit>{plural(schools, 'школа', 'школы', 'школ')}</Unit>
              <Spacer size={8} />
              <Text>{plural(schools, 'зарегистрирована', 'зарегистрировано')} на Учи.ру</Text>
            </NumberBlock>
            <Spacer size={24} />
            <NumberBlock>
              <NumberElement>{registeredTeachers}</NumberElement>
              <Spacer size={8} inline />
              <Unit>{plural(registeredTeachers, 'учитель', 'учителя', 'учителей')}</Unit>
              <Spacer size={8} />
              <Text>
                {plural(registeredTeachers, 'зарегистрирован', 'зарегистрированы')} на Учи.ру
                <br />
                за текущий год с 1 сентября
              </Text>
            </NumberBlock>
            <Spacer size={24} />
            <NumberBlock>
              <NumberElement>{activeTeachers}</NumberElement>
              <Spacer size={8} inline />
              <Unit>{plural(activeTeachers, 'учитель', 'учителя', 'учителей')}</Unit>
              <Spacer size={8} />
              <Text style={{ letterSpacing: '-0.14px' }}>
                в классах {plural(activeTeachers, 'которого', 'которых')} есть ученики, занимавшиеся в последние 30 дней
              </Text>
            </NumberBlock>
          </Row>
        </>
      )}
      <Spacer size={8} />
    </Plate>
  );
};
